import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Input, Label } from 'reactstrap';

export default function ScopeModal({ isOpen, toggle, scope, onSave }) {
  const isEdit = !!scope;

  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen) {
      setName(scope ? scope.name : '');
      setDescription(scope ? scope.description || '' : '');
      setError(null);
    }
  }, [isOpen, scope]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim()) {
      setError('Name is required.');
      return;
    }
    setSaving(true);
    setError(null);
    try {
      await onSave({ name: name.trim(), description: description.trim() || null });
      toggle();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="sm">
      <form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          {isEdit ? `Edit Scope — ${scope.name}` : 'New Scope'}
        </ModalHeader>
        <ModalBody>
          {error && <div className="error-banner">{error}</div>}

          <FormGroup>
            <Label className="form-label-custom">Name *</Label>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="read:users"
              required
            />
            <small style={{ color: '#8892a4', fontSize: 12 }}>
              Use snake_case or colon-separated format (e.g. read:orders)
            </small>
          </FormGroup>

          <FormGroup>
            <Label className="form-label-custom">Description</Label>
            <Input
              type="textarea"
              rows={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Optional description"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" type="button" onClick={toggle} disabled={saving}>
            Cancel
          </Button>
          <Button className="btn-primary" type="submit" disabled={saving}>
            {saving ? 'Saving...' : isEdit ? 'Update Scope' : 'Create Scope'}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
}
